import NOT_FOUND_IMAGE_SRC from '@/components/images/constants';

const GalleryImagesMixin = {
  computed: {
    galleryImages() {
      return this.listing.images.map(({ highResUrl, description, position }, index) => ({
        src: highResUrl,
        alt: `Listing Image ${index}`,
        reserveSrc: NOT_FOUND_IMAGE_SRC.LISTING,
        description,
        position,
      }));
    },
    galleryImagesSorted() {
      const images = this.galleryImages;

      return images.sort((a, b) => a.position - b.position);
    },
  },
};

export default GalleryImagesMixin;
